import React from "react";
import { useHistory, useParams, Link } from "react-router-dom";
import Header from "../components/common/Header";
import SideBar from "../components/common/SideBar";
import AuditTrail from "../components/StudentAdministration/Students/AuditTrail";
import LayoutCategory from "../components/layoutNavigation/LayoutCategory";
import LayoutMenus from "../components/layoutNavigation/LayoutMenus";
import LayoutHeaders from "../components/layoutNavigation/LayoutHeaders";
import LayoutTestimonials from "../components/layoutNavigation/layoutTestimonials/LayoutTestimonials";
import PermissionsGate from "../utils/permissionGate";
// This will be shown in merge-all branch

function LayoutNavigation() {
    const history = useHistory();
    const { tab, type } = useParams();

    return (
        <>
            <Header />
            <div className="content-wrapper d-flex flex-wrap">
                <SideBar />
                <div
                    className={
                        "sidebar-right " + (tab === "gradebook" ? "bottom-100" : "")
                    }
                >
                    <div className="sub-menu-content-block">
                        {/* <Tabs /> */}
                        <div className="sub-menu-right-block">
                            <div className="wrap-box-right">
                                <div className="my-tickets-heading-blk flex-direction mb-2">
                                    <div className="d-flex align-items-center ">
                                        <div className="name-w-head d-flex align-items-center ">
                                            <h4 class="text-left-align landing-heading heading_color_dynamic" title="Layout & Navigation">
                                                Layout <span>& Navigation</span>
                                            </h4>
                                        </div>
                                        <div className="text-md-right action2-blk">
                                            <div className="ticket-view-btn d-flex align-items-center">
                                                <div className="add-new-ticket-bx">
                                                    <button
                                                        onClick={() => history.goBack()}
                                                        title="Back"
                                                        className="btn btn-white-bordered"
                                                    >
                                                        <i className="fal fa-angle-left"></i>Back
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tabs-wrap">
                                    {(tab == "categories" ||
                                        tab == "menus" ||
                                        tab == "header" ||
                                        tab == "auditTrail" ||
                                        tab == "testimonials") && (
                                            <ul
                                                className="nav nav-pills mb-4"
                                                id="tabs"
                                                role="tablist"
                                            >
                                                <PermissionsGate scopes={['wbslncategoriesview']} RenderError={() => null}>
                                                <li
                                                    className="nav-item"
                                                    onClick={() =>
                                                        history.push(
                                                            `/websiteManagement/layout_navigation/categories/table`
                                                        )
                                                    }
                                                    >
                                                    <Link
                                                        className={`nav-link ${tab === "categories" && "active"
                                                        }`}
                                                        id="pills-tab1"
                                                        
                                                        data-toggle="pill"
                                                        to={`/websiteManagement/layout_navigation/categories/table`}
                                                        role="tab"
                                                        aria-controls="pills-tab11"
                                                        aria-selected="true"
                                                        title="Categories"
                                                        >
                                                        <i className="fa fa-layer-plus"></i>
                                                        Categories
                                                    </Link>
                                                </li>
                                                </PermissionsGate>
                                                <PermissionsGate scopes={['wbslnmenusview']} RenderError={() => null}>

                                                <li
                                                    className="nav-item"
                                                    onClick={() =>
                                                        history.push(
                                                            `/websiteManagement/layout_navigation/menus/table`
                                                        )
                                                    }
                                                    >
                                                    <Link
                                                        className={`nav-link ${tab === "menus" && "active"
                                                        }`}
                                                        id="pills-tab2"
                                                        data-toggle="pill"
                                                        to={`/websiteManagement/layout_navigation/menus/table`}
                                                        role="tab"
                                                        aria-controls="pills-tab12"
                                                        aria-selected="true"
                                                        title="Menus"
                                                        >
                                                        <i class="fa fa-bars"></i> Menus
                                                    </Link>
                                                </li>
                                                </PermissionsGate>
                                                <PermissionsGate scopes={['wbslnheadersview']} RenderError={() => null}>

                                                <li
                                                    className="nav-item"
                                                    onClick={() =>
                                                        history.push(
                                                            `/websiteManagement/layout_navigation/header/table`
                                                        )
                                                    }
                                                    >
                                                    <Link
                                                        className={`nav-link ${tab === "header" && "active"
                                                        }`}
                                                        id="pills-tab2"
                                                        data-toggle="pill"
                                                        to={`/websiteManagement/layout_navigation/header/table`}
                                                        role="tab"
                                                        aria-controls="pills-tab12"
                                                        aria-selected="true"
                                                        title="Headers"
                                                        >
                                                        <i class="fa fa-newspaper"></i> Headers
                                                    </Link>
                                                </li>
                                                </PermissionsGate>
                                                <PermissionsGate scopes={['wbslntestimonialsview']} RenderError={() => null}>

                                                <li
                                                    className="nav-item"
                                                    onClick={() =>
                                                        history.push(
                                                            `/websiteManagement/layout_navigation/testimonials/table`
                                                        )
                                                    }
                                                    >
                                                    <Link
                                                        className={`nav-link ${tab === "testimonials" && "active"
                                                        }`}
                                                        id="pills-tab2"
                                                        data-toggle="pill"
                                                        to={`/websiteManagement/layout_navigation/testimonials/table`}
                                                        role="tab"
                                                        aria-controls="pills-tab12"
                                                        aria-selected="true"
                                                        title="Testimonials"
                                                        >
                                                        <i class="fa fa-star"></i> Testimonials
                                                    </Link>
                                                </li>
                                                </PermissionsGate>
                                                <li
                                                    className="nav-item"
                                                    onClick={() =>
                                                        history.push(
                                                            `/websiteManagement/layout_navigation/auditTrail/table`
                                                        )
                                                    }
                                                >
                                                    <Link
                                                        className={`nav-link ${tab === "auditTrail" && "active"
                                                            }`}
                                                        id="pills-tab2"
                                                        data-toggle="pill"
                                                        to={`/websiteManagement/layout_navigation/auditTrail/table`}
                                                        role="tab"
                                                        aria-controls="pills-tab12"
                                                        aria-selected="true"
                                                        title="Audit trail"
                                                    >
                                                        <i className="fal fa-history"></i>Audit trail
                                                    </Link>
                                                </li>
                                            </ul>
                                        )}
                                    <div className="tab-content" id="pills-tabContent">
                                        <div
                                            className="tab-pane fade active show"
                                            id="pills-tab11"
                                            role="tabpanel"
                                            aria-labelledby="pills-tab1"
                                        >
                                            {(tab === "categories" && type == "table") && <LayoutCategory />}
                                            {(tab === "menus"  && type == "table") && <LayoutMenus />}
                                            {(tab === "header" && type == "table") && <LayoutHeaders />}
                                            {(tab === "testimonials" && type == "table") && <LayoutTestimonials/> }
                                            {(tab === "auditTrail" && type == "table") && <AuditTrail />}


                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LayoutNavigation;
